import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface JudgeAssignment {
    id: string;
    judgeId: string;
    eventId: string;
    judge?: { name: string; email: string };
    event?: { name: string; code: string };
}

export interface JudgeFest {
    id: string;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
    logo?: string;
    assignedEventCount: number;
}

interface JudgeState {
    assignments: JudgeAssignment[];
    fests: JudgeFest[];
    selectedFest: JudgeFest | null;
    loading: boolean;
    error: string | null;
}

const initialState: JudgeState = {
    assignments: [],
    fests: [],
    selectedFest: null,
    loading: false,
    error: null,
};

const judgeSlice = createSlice({
    name: 'Judge',
    initialState,
    reducers: {
        setAssignments: (state, action: PayloadAction<JudgeAssignment[]>) => {
            state.assignments = action.payload;
            state.loading = false;
            state.error = null;
        },
        setJudgeFests: (state, action: PayloadAction<JudgeFest[]>) => {
            state.fests = action.payload;
            if (state.selectedFest) {
                const stillValid = action.payload.some(f => f.id === state.selectedFest!.id);
                if (!stillValid) state.selectedFest = null;
            }
        },
        setSelectedJudgeFest: (state, action: PayloadAction<JudgeFest>) => {
            state.selectedFest = action.payload;
        },
        clearSelectedJudgeFest: (state) => {
            state.selectedFest = null;
        },
        clearJudgeState: (state) => {
            state.assignments = [];
            state.fests = [];
            state.selectedFest = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        addAssignment: (state, action: PayloadAction<JudgeAssignment>) => {
            state.assignments.unshift(action.payload);
        },
        removeAssignmentFromList: (state, action: PayloadAction<string>) => {
            state.assignments = state.assignments.filter((a) => a.id !== action.payload);
        },
    },
});

export const {
    setAssignments, setLoading, addAssignment, removeAssignmentFromList,
    setJudgeFests, setSelectedJudgeFest, clearSelectedJudgeFest, clearJudgeState,
} = judgeSlice.actions;
export default judgeSlice.reducer;
